<template>
  <v-row>
    <v-col cols="12" class="pt-0 pb-4">
      <Title title="Специальность на момент отчисления" font-size="15" text-start/>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="application.specialityFrom"
        :items="dictionaries.speciality"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Специальность</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="application.courseNumberFrom"
        :items="dictionaries.courseNumber"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Номер курса</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="application.expirationReason"
        :items="dictionaries.expirationReason"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Причина отчисления</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <DatePicker
        :prop-date="application.expirationDate"
        label="Дата отчисления"
        required
        @set-date="setExpirationDate"
      />
    </v-col>

    <v-col cols="12" class="pt-0 pb-4">
      <Title title="Специальность на восстановление" font-size="15" text-start/>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="application.specialityTo"
        :items="dictionaries.speciality"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Специальность</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="application.courseNumberTo"
        :items="dictionaries.courseNumber"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Номер курса</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="application.submissionSession"
        :items="isActualSubmissionSession"
        item-text="semester.name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Семестр</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="py-0">
      <v-autocomplete
        v-model="application.paidFormTo"
        :items="dictionaries.paidForm"
        item-text="name"
        clearable
        outlined
        rounded
        dense
        placeholder="Выберите из списка"
        no-data-text="Не найдено"
        return-object
        @input="setApplication"
      >
        <template #label>
          <span class="required">Тип обучения</span>
        </template>
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>

import {Application} from '@/models'
import Title from "@/components/ui/Title";
import DatePicker from "@/components/ui/DatePicker"
import {mapGetters} from "vuex"

export default {
  name: 'ApplicationRecovery',

  components: {
    Title,
    DatePicker
  },

  props: {
    item: Application
  },

  data() {
    return {
      application: new Application(),
    }
  },

  validations() {
    return {
      application: {
      }
    }
  },

  computed: {
    ...mapGetters('dictionaries', ['dictionaries', 'isActualSubmissionSession']),
  },

  methods: {
    setApplication() {
      this.$emit('set-data', this.application)
    },

    setExpirationDate(value) {
      this.application.expirationDate = value
      this.setApplication()
    },
  },

  watch: {
    'item.id': {
      immediate: true,
      handler() {
        this.application = Application.build(this.item)
      }
    }
  }
}
</script>
<style scoped>
</style>
